import { useAppDispatch, useAppSelector } from '@store/hooks';
import { selectCurrentCategory, setCurrentCategory } from '@store/mainReducer';
import { CATEGORIES } from '@utils/constants';
import React from 'react'
import { Nav } from 'react-bootstrap';
import ButtonCategory from '@components/UI/CategoryButton';
import styled from 'styled-components';

const StyledDiv = styled.div`
  .nav-pills .nav-link {
    color: #ffffff;
    font-weight: 500;
    border: 2px solid #fff;
    font-size: 12px;
    padding: 8px 8px;
  }
  .nav-pills .nav-link.active,
  .nav-pills .show > .nav-link {
    color: #000;
    background-color: #ffffff;
  }
  @media (max-width: 768px) and (min-width: 501px) {
    .nav-pills {
      display: grid !important;
      grid-template-columns: 1fr 1fr;
      gap: 4px;
    }
    .nav-pills .nav-link {
      font-size: 10px;
      padding: 4px 6px;
      border-width: 1px;
      text-align: center;
      width: 100%;
    }
  }
  @media (max-width: 500px) {
    .nav-pills .nav-link {
      font-size: 10px;
      padding: 4px 4px;
    }
  }
`;
const Categories = () => {
    const dispatch = useAppDispatch();
    const currentCategory = useAppSelector(selectCurrentCategory);

    const handleClick = (category: string): void => {
      dispatch(setCurrentCategory(category));
    };
  return (
    <StyledDiv>
    <Nav
              variant="pills"
              className="flex-row justify-content-between"
              activeKey={currentCategory}
            >
              {Object.keys(CATEGORIES).map((category: string, index: number) => {
                return <ButtonCategory handleClick={handleClick} key={index} label={category} />;
              })}
            </Nav>
            </StyledDiv>
  )
}

export default Categories
